@for (child of items; track child.routerLink + child.url) {
  @if (child.visible === false ? false : true) {
    <li [ngClass]="{'active': isActive($index)}" [class]="child.badgeStyleClass">
      @if (child.routerLink) {
        <a
          (click)="itemClick($event,child,$index)"
          [routerLink]="child.routerLink"
          routerLinkActive="route-active"
          [fragment]="child.fragment"
          [routerLinkActiveOptions]="{exact: true}"
          [attr.tabindex]="!visible ? '-1' : null"
          [attr.target]="child.target">
          @if (child.icon) {
            <i [ngClass]="child.icon"></i>
          }
          <span>{{child.label}}</span>
          @if (child.items) {
            <i class="pi pi-angle-down layout-menuitem-toggler"></i>
          }
          @if (child.badge) {
            <span class="menuitem-badge">{{child.badge}}</span>
          }
        </a>
      }
      @else {
      <a
        [href]="child.url||'#'"
        (click)="itemClick($event,child,$index)"
        [ngClass]="child.styleClass"
        [attr.tabindex]="!visible ? '-1' : null"
        [attr.target]="child.target">
        @if (child.icon) {
          <i [ngClass]="child.icon"></i>
        }
        <span>{{child.label}}</span>
        @if (child.items) {
          <i class="pi pi-angle-down layout-menuitem-toggler"></i>
        }
        @if (child.badge) {
          <span class="menuitem-badge">{{child.badge}}</span>
        }
      </a>
    }
    @if (child.items) {
      <ul theme-submenu
        [item]="child"
        [visible]="isActive($index)"
        [reset]="reset"
        [parentActive]="isActive($index)"
      [@children]="root ? isActive($index) ? 'visible' : 'hidden' : isActive($index) ? 'visibleAnimated' : 'hiddenAnimated'"></ul>
    }
  </li>
}
}
